import { getAncestorTrail } from '@ergeon/help-components';

import { defaultCategories } from 'data/help-categories';

import { WikiCrumb, WikiNode, WikiSection } from '../types';

export const WIKI_SECTIONS: WikiSection[] = defaultCategories;

export const getCurrentSectionKey = (node: WikiNode | null) => {
  if (!node) {
    return undefined;
  }
  const [section]: WikiCrumb[] = getAncestorTrail(node.breadcrumb);
  if (section) {
    return section.nodeKey;
  }
  return node.nodeKey;
};

type SectionCurrentState = 'page' | 'true' | undefined;

export const getSectionCurrentState = (sectionKey: string, node: WikiNode | null): SectionCurrentState => {
  if (!node || getCurrentSectionKey(node) !== sectionKey) {
    return undefined;
  }
  if (node.nodeKey === sectionKey) {
    return 'page';
  }
  return 'true';
};
